import { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { getUpcomingRaces } from '../services/api';

function UpcomingEvents() {
  const { t, i18n } = useTranslation();
  const [groups, setGroups] = useState([]);
  const [loading, setLoading] = useState(true);

  const locale = i18n.language === 'pt-BR' ? 'pt-BR' : 'en-US';

  function formatDateLabel(dateStr) {
    const d = new Date(dateStr);
    return d.toLocaleDateString(locale, { day: '2-digit', month: 'short', weekday: 'short' });
  }

  function formatTime(dateStr) {
    return new Date(dateStr).toLocaleTimeString(locale, { hour: '2-digit', minute: '2-digit' });
  }

  function groupByDate(sessions) {
    const groups = {};
    for (const s of sessions) {
      const key = new Date(s.start_time).toLocaleDateString(locale);
      if (!groups[key]) groups[key] = { label: formatDateLabel(s.start_time), sessions: [] };
      groups[key].sessions.push(s);
    }
    return Object.values(groups);
  }

  useEffect(() => {
    getUpcomingRaces()
      .then(data => {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const cutoff = new Date(today);
        cutoff.setDate(today.getDate() + 3);
        const filtered = data.filter(s => {
          const d = new Date(s.start_time);
          return d >= today && d < cutoff;
        });
        setGroups(groupByDate(filtered));
      })
      .catch(() => setGroups([]))
      .finally(() => setLoading(false));
  }, [i18n.language]); // re-agrupa ao trocar idioma

  return (
    <section id="upcoming-events" className="sidebar-box">
      <div className="box-header">
        <h3>{t('upcomingEvents.title')}</h3>
      </div>
      <div className="upcoming-list">
        {loading && <p style={{ color: '#9ba3ab', fontSize: '13px', padding: '8px 0' }}>{t('common.loading')}</p>}
        {!loading && groups.length === 0 && (
          <p style={{ color: '#9ba3ab', fontSize: '13px', padding: '8px 0' }}>{t('upcomingEvents.noRaces')}</p>
        )}
        {groups.map(group => (
          <div className="date-group" key={group.label}>
            <span className="date-label">{group.label}</span>
            {group.sessions.map(s => (
              <article className="upcoming-item" key={s.league_session_id}>
                <div className="event-time">{formatTime(s.start_time)}</div>
                <div className="event-info">
                  <span className="event-league">{s.league_name}</span>
                  <span className="event-cat">{s.championship_name}</span>
                  <span className="event-track">{[s.track_name, s.config_name].filter(Boolean).join(' — ')}</span>
                </div>
              </article>
            ))}
          </div>
        ))}
      </div>
      {!loading && groups.length > 0 && (
        <Link to="/races" className="view-all">{t('upcomingEvents.viewAll')}</Link>
      )}
    </section>
  );
}

export default UpcomingEvents;
